import { render, staticRenderFns } from "./FormPrincipalEditarFornecedor.vue?vue&type=template&id=5fe7429e"
import script from "./FormPrincipalEditarFornecedor.vue?vue&type=script&lang=js"
export * from "./FormPrincipalEditarFornecedor.vue?vue&type=script&lang=js"
import style0 from "./FormPrincipalEditarFornecedor.vue?vue&type=style&index=0&id=5fe7429e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports